module.exports = __webpack_public_path__ + "static/img/home_banner.6ad2140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_banner.png
// module id = ILbt
// module chunks = 21